import {
  DEFAULT_OLB_ENROLLMENT_GROUP_ID
} from "src/app/shared/constants";

export class Product {

  public productId: number;
  public name: string;
  public code: number;
  public isActive: boolean;
  public brandId: number;
  public brandName: string;
  private descriptorString: string;
  public descriptors: string[];
  public productInfoLink: string;
  public accountType: string;
  public productType: string;
  public interestRate: number;
  public interestPlanCodes: number[];
  public olbGroupId: number;
  public alloyWorkflowId: number;
  public allowJointApplications: boolean;
  public productUID: string
  public allowMultiProductApplications: boolean;

  constructor(productId?: number, name?: string, code?: number, isActive?: boolean, brandId?: number, brandName?: string, descriptorString?: string, productInfoLink?: string, separator: string = "|", accountType?: string, productType?: string, interestRate?: number, interestPlanCodes?: number[], olbGroupId?: number, alloyWorkflowId? : number, allowJointApplications?: boolean, productUID?: string, allowMultiProductApplications?: boolean) {
    this.productId = productId || 0;
    this.name = name || "";
    this.code = code || 0;
    this.isActive = isActive || false;
    this.brandId = brandId || 0;
    this.brandName = brandName || "";
    this.descriptorString = descriptorString || "";
    this.descriptors = this.buildDescriptorArray(descriptorString || "", separator);
    this.productInfoLink = productInfoLink || "";
    this.accountType = accountType || "";
    this.productType = productType || "";
    this.interestRate = interestRate || 0.0;
    this.interestPlanCodes = interestPlanCodes!;
    this.olbGroupId = olbGroupId || DEFAULT_OLB_ENROLLMENT_GROUP_ID;
    this.alloyWorkflowId = alloyWorkflowId || 0;
    this.allowJointApplications = allowJointApplications!;
    this.productUID = productUID!;
    this.allowMultiProductApplications = typeof(allowMultiProductApplications) === 'boolean' ? allowMultiProductApplications : true;
  }

  private buildDescriptorArray(descriptorString: string, separator: string): string[] {
    return descriptorString.split(separator).map(item => item.trim());
  }
}

